import { render } from "./VerifyCode.vue?vue&type=template&id=0474f5c6"
import script from "./VerifyCode.vue?vue&type=script&lang=js"
export * from "./VerifyCode.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__